module.exports = __webpack_public_path__ + "img/pefindo-logo.00f29136.svg";